'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = style;

var _glamorReact = require('glamor-react');

var _colors = require('../styles/colors');

var _flex = require('../styles/flex');

var _flex2 = _interopRequireDefault(_flex);

var _media = require('../styles/media');

var _helpers = require('../styles/helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function style() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _colors.COLORS.WHITE;

  return (0, _glamorReact.css)(_extends({}, (0, _colors.background)(color), (0, _helpers.padding)('1rem'), (0, _helpers.margin)('1rem'), (0, _flex2.default)({ direction: 'column' }), (0, _media.phone)({ width: '70%' }), (0, _media.desktop)({ width: '35%' }), {
    position: 'relative',
    width: '60%',
    borderRadius: '.25rem',
    borderBottom: '4px solid ' + _colors.COLORS.GREY
  }));
}


//////////////////
// WEBPACK FOOTER
// ./~/tanda-components/Card/styles.js
// module id = 1577
// module chunks = 0